import { MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { areas } from "./data";

const Areas = () => (
  <section id="areas" data-testid="areas-section" className="bg-slate-950 py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="max-w-2xl mb-14">
        <Overline light>Areas we cover</Overline>
        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          Based in Basildon. Working across Essex.
        </h2>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-400">
          If you're nearby but don't see your town listed, just ask — if we can
          get to you, we will.
        </p>
      </Reveal>

      <div data-testid="areas-list" className="flex flex-wrap gap-3 md:gap-4">
        {areas.map((a, i) => (
          <Reveal key={a} delay={i * 0.05}>
            <span className="inline-flex items-center gap-2 border border-slate-700 bg-slate-900 text-slate-100 font-semibold text-sm md:text-base px-6 py-3.5 rounded-md">
              <MapPin className="w-4 h-4 text-amber-400" />
              {a}
            </span>
          </Reveal>
        ))}
        <Reveal delay={areas.length * 0.05}>
          <span className="inline-flex items-center gap-2 bg-amber-400 text-slate-950 font-bold text-sm md:text-base px-6 py-3.5 rounded-md">
            + surrounding Essex areas
          </span>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Areas;
